export const getPendingActionType = (actionType: string) => `${actionType}/pending`;
